import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const KycAddressApi = createApi({
  reducerPath: "KycAddressApi",
  baseQuery,
  tagTypes: ["KycAddress"],

  endpoints: (builder) => ({
    getKycAddress: builder.query({ ///v1/customers/kycAddress/{customerId}
      query: ({ id }) =>`/customers/kycAddress/${id}`,
      transformResponse: (response) => response?.data?.[0] ?? [],
      providesTags: ["KycAddress"],
    }),

    createKycAddress: builder.mutation({
      query: ({ id, ...data }) => ({
        url:`/customers/kycAddress/${id}`, 
        method: "PUT",
        headers: { 
          "X-Request-Id": Math.random().toString(36).substring(2)
        },
        body: { kycAddress: data },
      }),
      invalidatesTags: ["KycAddress"],
    }),
 
  }),
});

export const {
  useLazyGetKycAddressQuery,
  useCreateKycAddressMutation

 
} = KycAddressApi;
